module.exports = "/_next/static/images/bg-blue-bar-1c2c7e47.png";